import { PageKeys, PageObjTypes } from './App.types';
import Appointment from './components/appointment/appointment';
import { Error } from './components/error/error';
import { Transfer } from './components/transfer/transfer';

export const pages: PageObjTypes[] = [
    { key: PageKeys.appointment, title: '', component: <Appointment /> },
    { key: PageKeys.transfer, title: '', component: <Transfer /> },
    { key: PageKeys.error, title: '', component: <Error /> },
];
